/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MarketRegisterAIcon16Light } from './MarketRegisterAIcon16Light';
import { MarketRegisterAIcon16Regular } from './MarketRegisterAIcon16Regular';
import { MarketRegisterAIcon16Solid } from './MarketRegisterAIcon16Solid';
import { MarketRegisterAIcon20Light } from './MarketRegisterAIcon20Light';
import { MarketRegisterAIcon20Regular } from './MarketRegisterAIcon20Regular';
import { MarketRegisterAIcon20Solid } from './MarketRegisterAIcon20Solid';
import { MarketRegisterAIcon24Regular } from './MarketRegisterAIcon24Regular';
import { MarketRegisterAIcon24Solid } from './MarketRegisterAIcon24Solid';
import { MarketRegisterAIcon32Regular } from './MarketRegisterAIcon32Regular';
import { MarketRegisterAIcon64Regular } from './MarketRegisterAIcon64Regular';
var sizes = {
    16: {
        light: MarketRegisterAIcon16Light,
        regular: MarketRegisterAIcon16Regular,
        solid: MarketRegisterAIcon16Solid,
    },
    20: {
        light: MarketRegisterAIcon20Light,
        regular: MarketRegisterAIcon20Regular,
        solid: MarketRegisterAIcon20Solid,
    },
    24: {
        regular: MarketRegisterAIcon24Regular,
        solid: MarketRegisterAIcon24Solid,
    },
    32: {
        regular: MarketRegisterAIcon32Regular,
    },
    64: {
        regular: MarketRegisterAIcon64Regular,
    },
};
export var MarketRegisterAIcon = forwardRef('MarketRegisterAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
